<template lang="html">
 <div>
    <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center">
            <div class="row g-0 align-self-center align-items-center justify-content-center" id="contactTitle">
                <div class="cta-3 text-primary">Réponse publiée</div>
            </div>

            <button type="button"  @click="delete_state()"  class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1 ms-auto"><i class="bi-trash"></i></button>
        </div>
        <div class="text-alternate">{{ human_created_on }}</div>

    </div>
</div>       
</template>

<script>
export default {
  name: "StateAnswerPublished",
  props: {
    context: {
      type: Object,
      required: true
    },
    human_created_on: String
  },
  methods: {
    delete_state() {
      this.$emit("state:delete_state");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
